import { useState, type FormEvent } from 'react';
import { AppShell } from './AppShell/AppShell';
import { Button } from './ui/Button';
import styles from './PasswordPrompt.module.css';

interface Props {
  onSubmit(pw: string): void;
  pending?: boolean;
  hint?: string;
}

export function PasswordPrompt({ onSubmit, pending, hint }: Props) {
  const [value, setValue] = useState('');

  const submit = (e: FormEvent) => {
    e.preventDefault();
    if (!value.trim() || pending) return;
    onSubmit(value.trim());
  };

  return (
    <AppShell variant="logo-only">
      <main className={styles.wrap}>
        <form className={styles.card} onSubmit={submit}>
          <i
            className={`ph-fill ph-lock-key ${styles.icon}`}
            aria-hidden="true"
          />
          <h1 className={styles.title}>This project is password protected.</h1>
          <p className={styles.lead}>Enter the password to continue.</p>

          <div className={styles.field}>
            <label htmlFor="pwInput" className={styles.label}>
              Password
            </label>
            <input
              id="pwInput"
              type="password"
              className={styles.input}
              placeholder="Password"
              value={value}
              onChange={(e) => setValue(e.target.value)}
              autoFocus
            />
            {hint && <div className={styles.hint}>{hint}</div>}
          </div>

          <div className={styles.actions}>
            <Button type="submit" disabled={!value.trim() || pending}>
              Continue <i className="ph-bold ph-arrow-right" />
            </Button>
          </div>
        </form>
      </main>
    </AppShell>
  );
}
